<template>
  <div class="content">
    <div class="email-container">
      <div class="email-card">
        <form>
          <!-- 标题 -->
          <div class="email-header">
            <h2>修改邮箱</h2>
            <p>无法直接修改邮箱，请联系客服</p>
          </div>

          <!-- 邮箱输入 -->
          <div class="form-group">
            <label>邮箱</label>
            <div class="input-group">
              <input v-model="email" type="text" placeholder="请输入邮箱地址" />
            </div>
          </div>

          <!-- 提示文字 -->
          <p class="email-tip">无法设置邮箱，<a @click="$parent.openKefu">联系客服</a></p>

          <!-- 提交按钮 -->
          <button type="button" class="submit-button" @click="isOk">确定</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modifyEmail',
  data() {
    return { email: null };
  },
  created() {
    this.email = this.$store.state.userInfo.email;
  },
  methods: {
    isOk() {
      const url = '/api/updateuserinfo';
      const info = {};
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));

      info.email = this.email;
      info.mobile = userInfo.mobile;
      info.birthday = userInfo.birthday;

      const regEmail = /^([a-zA-Z0-9_.\-])+@([a-zA-Z0-9\-])+(\.[a-zA-Z]{2,4})+$/;
      if (!regEmail.test(this.email)) {
        this.$parent.showTost(0, '请输入正确邮箱');
        return;
      }

      this.$parent.showLoading();
      this.$apiFun.post(url, info).then(res => {
        this.$parent.hideLoading();
        if (res.code !== 200) {
          this.$parent.showTost(0, res.message);
        } else {
          this.$parent.showTost(1, res.message);
          this.$parent.getUserInfos();
        }
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #f8fafc;
  min-height: 100vh;
  padding: 30px 15px;
  display: flex;
  justify-content: center;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 卡片容器 */
.email-container {
  width: 100%;
  max-width: 500px;
  box-sizing: border-box;
}

.email-card {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  box-sizing: border-box;
  width: 100%;
}

/* 标题 */
.email-header {
  text-align: center;
  margin-bottom: 30px;
}

.email-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 6px;
}

.email-header p {
  font-size: 14px;
  color: #718096;
}

/* 表单 */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #4a5568;
}

.input-group {
  position: relative;
  width: 100%;
}

.input-group input {
  width: 100%;
  padding: 12px 15px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #cbd5e0;
  box-sizing: border-box;
  transition: all 0.2s;
}

.input-group input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(66,153,225,0.2);
  background: #fff;
}

/* 提示文字 */
.email-tip {
  font-size: 13px;
  color: #718096;
  margin: 10px 0 20px;
}

.email-tip a {
  color: #4299e1;
  text-decoration: none;
  cursor: pointer;
}

.email-tip a:hover {
  text-decoration: underline;
}

/* 提交按钮 */
.submit-button {
  width: 100%;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(135deg, #4a90e2, #63b3ed);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(66,153,225,0.2);
  box-sizing: border-box;
}

.submit-button:hover {
  background: linear-gradient(135deg, #3b82f6, #4299e1);
  transform: translateY(-2px);
  box-shadow: 0 6px 10px rgba(66,153,225,0.3);
}

.submit-button:active {
  transform: translateY(0);
}

/* 响应式 */
@media (max-width: 480px) {
  .email-card {
    padding: 20px;
  }

  .email-header h2 {
    font-size: 20px;
  }

  .submit-button {
    padding: 12px 0;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/modifyEmail.vue